import { Component, EventEmitter, Input, OnChanges, Output, signal } from "@angular/core";
import { IMPORTS } from './_imports';

@Component({
    selector: 'announcer',
    templateUrl: './announcer.component.html',
    styleUrl: './announcer.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class AnnouncerComponent implements OnChanges {
    // #region [signals]
    $title = signal('');
    $message = signal('');
    $level = signal('primary');

    $isVisible = signal(true);
    // #endregion

    // #region [Input/Output]
    @Input() _title: string;
    @Input() _message: string;
    @Input() _level: string;
    @Output() _isVisibleEvent = new EventEmitter<boolean>();
    // #endregion

    constructor() { }

    ngOnChanges() {
        this.$title.set(this._title);
        this.$message.set(this._message);
        this.$level.set(this._level);
    }

    close() {
        this.$isVisible.set(false);
        this._isVisibleEvent.emit(false);
    }
}
